import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';

import { registerSupport } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    // height: '100%',
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  }
}));

const RegisterSupport = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        container
      >
        <Grid
          component="article"
          container
        >
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
          >
            <Paper className={classes.paper}>
              <CardMedia
                alt={registerSupport[0].alt}
                component="img"
                object-fit
                src={registerSupport[0].img}
                title={registerSupport[0].title}
              />
            </Paper>
          </Grid>
          <Grid
            alignItems="center"
            container
            md={6}
            sm={12}
            xs={12}
          >
            <Paper
              className={classes.paper}
            >
              <Typography
                component="h2"
                variant="h2"
              >
                Inscrivez vous à la béta
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                Inscrivez-vous à la bétâ ou pré commander le jeu dès maintenant !
              </Typography>
              <NavLink to="/game-order">
                <Button
                  color="secondary"
                  size="large"
                  variant="contained"
                >
                Précommande
                </Button>

              </NavLink>
            </Paper>
          </Grid>

        </Grid>
        <Grid
          container
        >
          <Grid
            alignItems="center"
            container
            md={6}
            sm={12}
            xs={12}
          >
            <Paper
              align="right"
              className={classes.paper}
            >
              <Typography
                component="h2"
                variant="h2"
              >
                Soutenez SeedOut Fenua
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                NOUS joueurs, faisons partie d'une communauté immense qui n’a pas peur de s’engager dans des quêtes impossibles.
              </Typography>
              <NavLink to="/game-order">

                <Button
                  color="secondary"
                  size="large"
                  variant="contained"
                >
                NOUS SOUTENIR
                </Button>
              </NavLink>
            </Paper>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
          >
            <Paper className={classes.paper}>
              <CardMedia
                alt={registerSupport[1].alt}
                component="img"
                object-fit
                src={registerSupport[1].img}
                title={registerSupport[1].title}
              />
            </Paper>
          </Grid>

        </Grid>
      </Grid>
    </>
  );
}

export default RegisterSupport;
